<template>
  <div
    ref="draggableContainer"
    :class="['draggable-image', imageOpened && 'draggable-image--draggable']"
    @mousedown="dragMouseDown"
    @mouseenter="hoverHandler(true)"
    @mouseleave="hoverHandler(false)"
    @click="openImage()"
  >
    <div
      :class="[
        'draggable-image__wrapper',
        imageOpened && 'draggable-image__wrapper--draggable',
      ]"
    >
      <XIcon
        v-if="imageOpened && closeIcon"
        class="draggable-image__close"
        @click.stop="closeImage()"
      />
      <img :src="imgSrc" alt="Content Image" />
    </div>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'DraggableImage',
  components: {
    XIcon,
  },
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imageOpened: false,
      closeIcon: false,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
    }
  },
  methods: {
    openImage() {
      if (this.imageOpened) return
      const draggableContainer = this.$refs.draggableContainer
      const offsetRight =
        window.innerWidth -
        draggableContainer.offsetLeft -
        draggableContainer.offsetWidth
      draggableContainer.style.top =
        draggableContainer.offsetParent.offsetTop + 'px'
      draggableContainer.style.right = offsetRight + 20 + 'px'
      draggableContainer.style.left = 'unset'
      this.imageOpened = true
    },
    closeImage() {
      this.imageOpened = false
    },
    dragMouseDown: function(event) {
      if (!this.imageOpened) return
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function(event) {
      const draggableContainer = this.$refs.draggableContainer
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      draggableContainer.style.top =
        draggableContainer.offsetTop - this.positions.movementY + 'px'
      draggableContainer.style.left =
        draggableContainer.offsetLeft - this.positions.movementX + 'px'
    },
    closeDragElement() {
      document.onmouseup = null
      document.onmousemove = null
    },
    hoverHandler(value) {
      if (this.imageOpened) {
        this.closeIcon = value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.draggable-image {
  z-index: 9;
  &--draggable {
    position: absolute;
    width: min(60vw, 600px) !important;
  }
  &__wrapper {
    position: relative;
    display: flex;
    z-index: 10;
    cursor: zoom-in;
    &:hover:not(.draggable-image__wrapper--draggable) {
      filter: brightness(60%);
    }
    &--draggable {
      position: static;
      cursor: move;
      img {
        border-radius: 10px;
      }
    }
    img {
      width: 100%;
    }
  }
  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 150;
    cursor: pointer;
  }
}
</style>
